import { render, staticRenderFns } from "./DashboardPayschedulesTab.vue?vue&type=template&id=3bbff4c5&scoped=true&"
import script from "./DashboardPayschedulesTab.vue?vue&type=script&setup=true&lang=js&"
export * from "./DashboardPayschedulesTab.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DashboardPayschedulesTab.vue?vue&type=style&index=0&id=3bbff4c5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbff4c5",
  null
  
)

export default component.exports